<template>
    <div class="blank">
        <div class="about-top">
            <div class="about-icon"></div>
            <p class="za-title">点点</p>
            <p class="za-info">v1.0.0</p>
            <group>
                <cell title="关于点点" @click="nextRoute('aboutdetail')">
                    <div slot="right">
                        <img class="icon" src="../assets/images/link.png" height="12" width="7" alt="">
                    </div>
                </cell>
                <cell title="客服电话" @click="tel()">
                    <div slot="right" class="about-right">
                        <p>1010-9955</p>
                        <p>工作日：09:00-18:00</p>
                    </div>
                </cell>
            </group>
        </div>
        <p class="about-bottom"> Copyright © 点点</p>
    </div>
</template>
<style lang="sass">
@import '../assets/styles/all.scss';

.about-top {
    background: rgb(246, 246, 246);
    padding-top: r(32);
    .about-icon {
        width: r(85);
        height: r(85);
        margin: 0 auto;
        background-image: url('../assets/images/192@2x.png');
        background-size: cover;
    }
    .za-title {
        margin-top: r(15);
        line-height: r(20);
        color: #000;
        font-weight: bold;
        font-size: r(16);
        text-align: center;
    }
    .za-info {
        margin-top: r(5);
        margin-bottom: r(20);
        line-height: r(20);
        color: #999;
        text-align: center;
        font-size: r(16);
    }
    .about-text {
        position: relative;
        margin: r(16);
        padding: r(16) 0;
        color: #000;
        &:before {
            @extend .setTopLine;
        }
    }
}
.about-right > p {
    line-height: r(16);
    font-size: r(14);
}
.about-bottom {
    position: absolute;
    width: 100%;
    color: #999;
    bottom: r(16);
    text-align: center;
}
.fiui-cell .fiui-cell-hd>p {
    font-weight: 300;
    color: #000;
    font-size: r(16);
}
</style>
<script>
    import { Group, Cell } from 'fiui'
    export default {
        components: {
            Group,
            Cell
        },
        beforeRouteEnter (to, from, next) {
            document.title = '关于我们'
            next()
        },
        methods: {
            nextRoute (route) {
                this.$router.push(route)
            },
            tel () {
                window.location.href = 'tel:1010-9955'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// aboutus.vue?075d3cd0